import React from "react";
import { ErrorMessage } from "../Authentication/ErrorMessage";
import { AccountTitle } from "../Common/__styles__/AccountLogo";
import { FlexRow } from "../Common/__styles__/Layout";
import { Section, Sections } from "../Common/Layout";
import { Body, Title } from "../Common/Typography";
import { SelectionCard } from "../Inputs/SelectionCard";

type SSOProvider = {
  id: string;
  name: string;
  enabled: boolean;
};

export const SSOProviderPicker = ({
  providers,
  account,
  error,
}: {
  providers: SSOProvider[];
  account: {
    id: string;
    name: string;
    logoUrl: string;
  };
  error?: { message: string } | null;
}) => {
  const handleProviderSelect = (providerId: string) => {
    window.location.href = `/auth/sso/initiate?accountId=${account.id}&providerId=${providerId}`;
  };

  return (
    <Sections>
      {error && <ErrorMessage error={error} />}
      <Section>
        <Title type="semiBold" size="large">
          Select your identity provider
        </Title>
        <Body size="default" type="regular" color="contentSecondary">
          Choose your organization's SSO provider to complete sign in.
        </Body>
        <SelectionCard.Group
          handleSelection={handleProviderSelect}
          direction="vertical"
          spacing="compact"
        >
          {providers.map(provider => (
            <SelectionCard.Item
              key={provider.id}
              value={provider.id}
              borderStyle="ghost"
              size="compact"
            >
              <FlexRow gap="s">
                <AccountTitle>{provider.name[0]}</AccountTitle>
                <SelectionCard.CommonContent title={provider.name} />
              </FlexRow>
            </SelectionCard.Item>
          ))}
        </SelectionCard.Group>
      </Section>
    </Sections>
  );
};
